import { useEffect } from 'react';

/**
 * Manages CSS classes on document.body via useEffect.
 * Replaces react-body-classname which uses componentWillMount (broken in React 18).
 *
 * @param {string} className - Space-separated class names to add to body
 */
export default function useBodyClassName(className) {
	useEffect(() => {
		if (typeof document === 'undefined' || !className) return;

		const classes = className.split(/\s+/).filter(Boolean);
		if (classes.length === 0) return;

		classes.forEach((cls) => document.body.classList.add(cls));

		return () => {
			classes.forEach((cls) => document.body.classList.remove(cls));
		};
	}, [className]);
}
